import apiEndpoints from 'api/endpoints';

import { baseAPI } from './baseApi';

export const userProfileAPI = baseAPI.injectEndpoints({
    endpoints: (builder) => ({
        fetchAllSOCRecords: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.getSOCRecords}`,
                method: 'POST',
                body: payload,
            }),
        }),

        fetchAllGWCRecords: builder.query({
            query: ({ uuId }) => ({
                url: `${apiEndpoints.getGWCRecords}/${uuId}/fetch`,
                method: 'GET',
            }),
        }),

        initiateSOCApi: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.initiateSOC}`,
                method: 'POST',
                body: payload,
            }),
        }),

        initiateGWCApi: builder.mutation({
            query: ({ uuId }) => ({
                url: `${apiEndpoints.initiateGWC}/${uuId}`,
                method: 'POST',
            }),
        }),

        initiateSevenYearData: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.getSevenYearCriminalData}`,
                method: 'POST',
                body: payload,
            }),
        }),

        fetchSevenYearRecord: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.fetchSevenYearCriminalData}`,
                method: 'POST',
                body: payload,
            }),
        }),

        getWorkflowOverview: builder.mutation({
            query: ({ uuid }) => ({
                url: `${apiEndpoints.workflowUrl}/user/${uuid}/status`,
                method: 'GET',
            }),
        }),

        getLogVerificationResult: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.eventLogs}`,
                method: 'POST',
                body: payload,
            }),
        }),

        fetchUserMetaData: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.userMetaData}`,
                method: 'POST',
                body: payload,
            }),
        }),

        fetchTestResult: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.getTestResult}`,
                method: 'POST',
                body: payload,
            }),
            providesTags: (result, error, { userAccessCode }) => [
                { type: 'TestResult', id: userAccessCode },
            ],
        }),

        provideConsent: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.consent}`,
                method: 'POST',
                body: {
                    userAccessCode: payload.userAccessCode,
                    isBackgroundDisclosureAccepted: 1,
                    GLBPurposeAndDPPAPurpose: 1,
                    FCRAPurpose: 1,
                    fullName: payload.fullName,
                },
            }),
        }),

        updateUserInfo: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.updateUser}`,
                method: 'PUT',
                body: payload,
            }),
        }),

        getUserMetaData: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.userMetaData}`,
                method: 'POST',
                body: payload,
            }),
        }),

        updateUserData: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.updateUser}`,
                method: 'PUT',
                body: payload,
            }),
        }),

        assignWorkflow: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.getJwtToken}`,
                method: 'POST',
                body: payload,
            }),
        }),

        reassignWorkflow: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.getJwtToken}`,
                method: 'PATCH',
                body: payload,
            }),
        }),

        fetchLatestJwtSetting: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.getLatestJwtSetting}`,
                method: 'POST',
                body: payload,
            }),
        }),

        runRiskScore: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.riskScore}`,
                method: 'POST',
                body: payload,
            }),
        }),

        runRiskInsights: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.riskInsights}`,
                method: 'POST',
                body: payload,
            }),
        }),

        fetchRiskScoreAndInsightsResult: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.fetchScoreAndInsight}`,
                method: 'POST',
                body: payload,
            }),
        }),

        verifySSN: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.verifySsn}`,
                method: 'POST',
                body: payload,
            }),
        }),

        runAuthDBCheck: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.authDBCheck}`,
                method: 'POST',
                body: payload,
            }),
        }),

        fetchSevenYearCriminalActivity: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.fetchSevenYearCriminalData}`,
                method: 'POST',
                body: payload,
            }),
        }),

        fetchTCMRecords: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.getTcmRecords}`,
                method: 'POST',
                body: payload,
            }),
        }),

        fetchTCMStatus: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.getTcmStatus}`,
                method: 'POST',
                body: payload,
            }),
        }),

        addUserToTCM: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.addToTcm}`,
                method: 'POST',
                body: payload,
            }),
        }),

        removeUserFromTCM: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.removeFromTcm}`,
                method: 'DELETE',
                body: payload,
            }),
        }),

        runSeverYearCriminalCheck: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.getSevenYearCriminalData}`,
                method: 'POST',
                body: payload,
            }),
        }),

        fetchMVRRecords: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.fetchMvr}`,
                method: 'POST',
                body: payload,
            }),
        }),

        fetchEducationResults: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.educationVerificationResult}`,
                method: 'POST',
                body: payload,
            }),
        }),

        fetchEmploymentResults: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.employmentVerificationResult}`,
                method: 'POST',
                body: payload,
            }),
        }),

        fetchProfessionalLicenseResults: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.professionalLicenseVerificationResult}`,
                method: 'POST',
                body: payload,
            }),
        }),

        getExtendedCheckStatus: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.extendedCheckStatus}`,
                method: 'POST',
                body: payload,
            }),
        }),

        runFederalCriminalCheck: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.federalCriminal}`,
                method: 'POST',
                body: payload,
            }),
        }),

        runFederalCivilCheck: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.federalCivil}`,
                method: 'POST',
                body: payload,
            }),
        }),

        initiateMvrCheck: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.identityMvr}`,
                method: 'POST',
                body: payload,
            }),
        }),

        fetchDegreeName: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.getDegreeName}`,
                method: 'POST',
                body: payload,
            }),
        }),

        fetchSchoolName: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.getSchoolName}`,
                method: 'POST',
                body: payload,
            }),
        }),

        fetchLicenseTitle: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.getLicenseTitle}`,
                method: 'POST',
                body: payload,
            }),
        }),

        verifyEducation: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.educationRequest}`,
                method: 'POST',
                body: payload,
            }),
        }),

        verifyEmployment: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.employerRequest}`,
                method: 'POST',
                body: payload,
            }),
        }),

        verifyProfessionalLicense: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.professionalLicenseRequest}`,
                method: 'POST',
                body: payload,
            }),
        }),

        resumeWorkflow: builder.mutation({
            query: (payload) => ({
                url: `admin/workflow/user/${payload.userAccessCode}/resume`,
                method: 'POST',
            }),
        }),

        attachAddonCheckToWorkflow: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.attachAddonCheckToWorkflow}`,
                method: 'POST',
                body: payload,
            }),
        }),

        initiateUserPdfReport: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.initiatePdfReport}`,
                method: 'POST',
                body: payload,
            }),
        }),

        getPdfReportConfig: builder.mutation({
            query: (payload) => ({
                url: apiEndpoints.getPdfReportConfig,
                method: 'POST',
                body: payload,
            }),
        }),

        removeAddonCheck: builder.mutation({
            query: (payload) => ({
                url: `${apiEndpoints.attachAddonCheckToWorkflow}`,
                method: 'DELETE',
                body: payload,
            }),
        }),
    }),
});

export const {
    useFetchAllSOCRecordsMutation: useFetchSOCRecords,
    useLazyFetchAllGWCRecordsQuery: useFetchGWCRecords,
    useInitiateGWCApiMutation: useInitiateGWC,
    useInitiateSOCApiMutation: useInitiateSOC,
    useInitiateSevenYearDataMutation: useInitiateSevenYearData,
    useFetchSevenYearRecordMutation: useFetchSevenYearRecord,
    useGetWorkflowOverviewMutation: useGetWorkflowOverview,
    useGetLogVerificationResultMutation: useGetLogVerificationResult,
    useFetchUserMetaDataMutation: useFetchUserMetaData,
    useFetchTestResultMutation: useFetchTestResult,
    useProvideConsentMutation: useProvideConsent,
    useUpdateUserInfoMutation: useUpdateUserInfo,
    useGetUserMetaDataMutation: useGetUserMetaData,
    useUpdateUserDataMutation: useUpdateUserData,
    useAssignWorkflowMutation: useAssignWorkflow,
    useReassignWorkflowMutation: useReassignWorkflow,
    useFetchLatestJwtSettingMutation: useFetchLatestJwtSetting,
    useRunRiskScoreMutation: useRunRiskScore,
    useRunRiskInsightsMutation: useRunRiskInsights,
    useFetchRiskScoreAndInsightsResultMutation: useFetchRiskScoreAndInsightsResult,
    useVerifySSNMutation: useVerifySSN,
    useRunAuthDBCheckMutation: useRunAuthDBCheck,
    useFetchSevenYearCriminalActivityMutation: useFetchSevenYearCriminalActivity,
    useFetchTCMRecordsMutation: useFetchTCMRecords,
    useFetchTCMStatusMutation: useFetchTCMStatus,
    useAddUserToTCMMutation: useAddUserToTCM,
    useRemoveUserFromTCMMutation: useRemoveUserFromTCM,
    useFetchMVRRecordsMutation: useFetchMVRRecords,
    useFetchEducationResultsMutation: useFetchEducationResults,
    useFetchEmploymentResultsMutation: useFetchEmploymentResults,
    useFetchProfessionalLicenseResultsMutation: useFetchProfessionalLicenseResults,
    useGetExtendedCheckStatusMutation: useGetExtendedCheckStatus,
    useRunSeverYearCriminalCheckMutation: useRunSeverYearCriminalCheck,
    useRunFederalCriminalCheckMutation: useRunFederalCriminalCheck,
    useRunFederalCivilCheckMutation: useRunFederalCivilCheck,
    useInitiateMvrCheckMutation: useInitiateMvrCheck,
    useFetchDegreeNameMutation: useFetchDegreeName,
    useFetchSchoolNameMutation: useFetchSchoolName,
    useFetchLicenseTitleMutation: useFetchLicenseTitle,
    useVerifyEducationMutation: useVerifyEducation,
    useVerifyEmploymentMutation: useVerifyEmployment,
    useVerifyProfessionalLicenseMutation: useVerifyProfessionalLicense,
    useResumeWorkflowMutation: useResumeWorkflow,
    useAttachAddonCheckToWorkflowMutation: useAttachAddonCheckToWorkflow,
    useInitiateUserPdfReportMutation: useInitiateUserPdfReport,
    useGetPdfReportConfigMutation: useGetPdfReportConfig,
    useRemoveAddonCheckMutation: useRemoveAddonCheck,
} = userProfileAPI;

export default userProfileAPI.middleware;
